export const messageTemplate = `あなたのプロフィールを拝見してとても興味を持ちました。
弊社では現在あなたのスキルが活かせる職種での採用を検討しております。
そこで、もしご都合がよければ、顔合わせと意見交換も兼ねて
弊社のメンバーとカジュアルにオンラインか対面のどちらかでお話してみませんか？`
